// AWS API
import { API } from 'aws-amplify';
import * as Errors from '../helpers/_getErrors';


export interface RequestInterface {
    body?: any;
    err?: any;
    headers?: string[];
    queryStringParameters?: any;
}

export default abstract class BaseService {
    protected readonly _apiName: string;
    protected readonly _path: string;
    protected _Errors = Errors.default

    constructor(apiName: string, path: string) {
        this._apiName = apiName;
        this._path = path;
    }

    protected setFields(fields?: string[]) {
        if (fields && fields.length) {
            return { fields: fields.join(',') };
        }
        return {};
    }

    protected async get<T>(path: string, request?: RequestInterface): Promise<T> {
        try {
            const res = await API.get(this._apiName, this._path + '/' + path, request);
            return res.data;
        } catch (error) {
            const res = this._Errors.get(error);
            throw res
        }
    }

    protected async export<T>(path: string, request?: RequestInterface): Promise<T> {
        try {
            const res = await API.get(this._apiName, this._path + '/' + path, request);
            return res;
        } catch (error) {
            const res = this._Errors.get(error);
            throw res
        }
    }
    protected async post<T>(path: string, request?: RequestInterface): Promise<T> {
        try {
            const res = await API.post(this._apiName, `${this._path}/${path}`, request);
            return res.data;
        } catch (error) {
            const res = this._Errors.get(error);
            throw res
        }

    }

    protected async postGraphQl<T>(path: string, request?: RequestInterface): Promise<T> {
        try {
            const res = await API.post(this._apiName, `${this._path}/${path}`, request);

            return res;
        } catch (error) {
            const res = this._Errors.get(error);
            throw res
        }

    }

    protected async put<T>(path: string, request?: RequestInterface): Promise<T> {
        try {
            const res = await API.put(this._apiName, `${this._path}/${path}`, request);
            return res.data;
        } catch (error) {
            const res = this._Errors.get(error);
            throw res
        }
    }

    protected async patch<T>(path: string, request?: RequestInterface): Promise<T> {
        try {
            const res = await API.patch(this._apiName, `${this._path}/${path}`, request);
            return res.data;
        } catch (error) {
            const res = this._Errors.get(error);
            throw res
        }
    }

    async delete<T>(path: string, request?: RequestInterface): Promise<T> {
        try {
            const res = await API.del(this._apiName, `${this._path}/${path}`, request);
            return res.data;
        } catch (error) {
            const res = this._Errors.get(error);
            throw res
        }
    }
}